/* One disclosure at a time; native summaries retain keyboard semantics. */
if (!customElements.get('pa-navigation')) {
  customElements.define('pa-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.groups = [...this.querySelectorAll('details')];
      this.close = (except = null) => {
        for (const group of this.groups) {
          if (group === except || !group.open) continue;
          // Never strand focus in content that is about to become hidden.
          if (group.contains(document.activeElement)) group.querySelector('summary').focus();
          group.open = false;
        }
      };
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) {
          event.preventDefault();
          const group = summary.parentElement;
          const opening = !group.open;
          this.close(group);
          group.open = opening;
          summary.focus();
        } else if (event.target.closest('a')) this.close();
      }, { signal });
      this.addEventListener('toggle', event => {
        if (this.groups.includes(event.target) && event.target.open) this.close(event.target);
      }, { capture: true, signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.groups.some(group => group.open)) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        }
      }, { signal });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget) {
          if (!this.contains(event.relatedTarget)) this.close();
        } else {
          // Some browser/assistive-technology paths finish focus movement after focusout.
          setTimeout(() => {
            if (this.isConnected && !this.contains(document.activeElement)) this.close();
          }, 0);
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      // Impact emits a bubbling toggle when its search/cart/navigation dialogs open.
      document.addEventListener('toggle', event => {
        if (!this.contains(event.target) && event.target.hasAttribute?.('open')) this.close();
      }, { capture: true, signal });
      document.addEventListener('dialog:after-show', () => this.close(), { signal });
      document.addEventListener('shopify:section:unload', () => this.close(), { signal });
      const breakpoint = matchMedia('(min-width: 1150px)');
      breakpoint.addEventListener('change', () => {
        const hadFocus = this.contains(document.activeElement);
        this.close();
        if (hadFocus && !document.activeElement.getClientRects().length) {
          const target = breakpoint.matches
            ? document.querySelector('.pa-navigation.header__link-list summary')
            : document.querySelector('button[aria-controls="header-sidebar-menu"]');
          target?.focus();
        }
      }, { signal });
      this.close();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
